import React from "react";

const TimePicker = ({ timeDetails, setTimeDetails }) => {
  const handleHourChange = (item) => {
    setTimeDetails((prev) => ({
      ...prev,
      hour: {
        value:
          item === 0
            ? "12"
            : item.toString().length === 1
            ? "0" + item
            : item.toString(),
        index: item
      }
    }));
  };

  const handleMinutesChange = (item) => {
    setTimeDetails((prev) => ({
      ...prev,
      minutes: {
        value: item.toString().length === 1 ? "0" + item : item.toString(),
        index: item
      }
    }));
  };

  const handleTypeChange = (item) => {
    setTimeDetails((prev) => ({ ...prev, type: item }));
  };

  return (
    <div onClick={(e) => e.stopPropagation()} className="time-picker-main">
      <div className="time-picker-inner">
        <div className="vertical-time-div">
          {[...Array(12)].map((_, index) => (
            <div
              key={index}
              onClick={() => handleHourChange(index)}
              className={`time-unit ${
                index === timeDetails.hour.index ? "selected" : ""
              }`}
            >{`${
              index === 0
                ? "12"
                : index.toString().length === 1
                ? "0" + index
                : index
            }`}</div>
          ))}
        </div>
        <div className="vertical-time-div">
          {[...Array(60)].map((_, index) => (
            <div
              key={index}
              onClick={() => handleMinutesChange(index)}
              className={`time-unit ${
                index === timeDetails.minutes.index ? "selected" : ""
              }`}
            >{`${index.toString().length === 1 ? "0" + index : index}`}</div>
          ))}
        </div>
        <div className="vertical-time-div">
          <div
            onClick={() => handleTypeChange("AM")}
            className={`time-unit ${
              timeDetails.type === "AM" ? "selected" : ""
            }`}
          >
            AM
          </div>
          <div
            onClick={() => handleTypeChange("PM")}
            className={`time-unit ${
              timeDetails.type === "PM" ? "selected" : ""
            }`}
          >
            PM
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimePicker;
